import { render, staticRenderFns } from "./FieldClients.vue?vue&type=template&id=3143c6a2"
import script from "./FieldClients.vue?vue&type=script&lang=js"
export * from "./FieldClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports